import React, { useState } from 'react';
import { GetStaticProps } from 'next';
import { getSharedPageProps, SharedPageProps } from 'components/Layout';
import {
    Container,
    Heading,
    Grid,
    GridItem,
    Box,
    SimpleGrid,
    Select,
} from '@chakra-ui/react';
import { blockPadding } from 'constants/constants';
import UnitCard from 'components/unit/UnitCard';
import { FacilityContent } from 'types/umbraco';
import { GetFacilitiesContent } from 'helpers/umbracoApi'
import CampaignBanner from 'components/campaigns/CampaignBanner';

interface UnitsPageProps {
    sharedPageProps: SharedPageProps;
    facilities: FacilityContent[];
    content: any
}

const UnitsPage = (
    { facilities, sharedPageProps, content }: UnitsPageProps
): JSX.Element => {
    const [activeFacility, setActiveFacility] = useState('')

    const namesToMatch = sharedPageProps.facilities?.map(facility => facility.name)
    console.log(facilities, 'facilities')
    // Getting array of unique name string, set are not liked by TS, hence the weird array.from[..Set]
    const locations: string[] = [...Array.from(new Set(sharedPageProps.facilities.map(x => x.location.name)))].filter((v, i, a) => a.indexOf(v) === i);

    const filteredFacilities = facilities.filter(y => namesToMatch.includes(y.name)).filter(x => activeFacility.length > 0 ? x.name.split(' ')[0] === activeFacility : x)
    console.log(sharedPageProps)
    return (
        <>
            <CampaignBanner campaigns={sharedPageProps.campaigns} campaignLevel='Top' />
            <Box p={blockPadding}>
                <Container>
                    <Grid templateColumns={{ base: '1fr', md: '4fr 8fr' }}>
                        <GridItem>
                            <Heading as="h1" fontSize="xl" fontWeight="600" mb={5}>{content.header}</Heading>
                            <Box dangerouslySetInnerHTML={{ __html: content.rteText }} fontSize={14} fontWeight="400" mb={5} pr={5} />
                            <Box w={300}>
                                <Select onChange={(e) => setActiveFacility(e.target.value)}> <option value="">Alla städer</option>{locations.map(location => <option style={{ borderRight: '1px solid black' }} key={location} value={location}>{location}</option>)}</Select>
                            </Box>
                        </GridItem>
                        <GridItem>
                            <SimpleGrid columns={2} spacing={10}>
                                {filteredFacilities.map((facility) => (
                                    <UnitCard key={facility.id} facility={facility} />
                                ))}
                            </SimpleGrid>
                        </GridItem>
                    </Grid>
                </Container>
            </Box>
        </>
    );
};

export const getStaticProps: GetStaticProps = async () => {
    const sharedPageProps: SharedPageProps = await getSharedPageProps();
    const { facilities, content } = await GetFacilitiesContent();
    return {
        props: { ...sharedPageProps, facilities, content }
    };
};

export default UnitsPage;
